module.exports = __webpack_public_path__ + "img/ch4-emissions.b019ecd3.svg";